// removed by extract-text-webpack-plugin
module.exports = {"appTitle":"_-src-components-ArticleList-index---appTitle---1kQJd","loader":"_-src-components-ArticleList-index---loader---3wcFr","list":"_-src-components-ArticleList-index---list---dxbBH","container":"_-src-components-ArticleList-index---container---3z12o","listHeader":"_-src-components-ArticleList-index---listHeader---2BNHp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ArticleList/index.css
// module id = 737
// module chunks = 1